import { call, put, takeLatest } from "redux-saga/effects";
import { showToast } from "../../../components";
import {
  addInvoicesStart,
  getAllInvoicesFailure,
  getAllInvoicesStart,
  getAllInvoicesSuccess,
  getCurrentInvoiceStart,
  getDueInvoiceFail,
  getDueInvoicesStart,
  getEmpAllInvoicesStart,
  getFailCurrentInvoice,
  getOpenInvoicesStart,
  getPaidInvoicesStart,
  successDueInvoiceStart,
  successEmpAllInvoices,
  successGetCurrentInvoiceStart,
  successOpenInvoiceStart,
  successPaidInvoiceStart,
} from "./invoicesSlice";
import {
  addInvoicesApi,
  fetchAllInvoices,
  fetchInvoicesByUiid,
  updateInvoice,
} from "./invoicesApi";

function* getAllInvoicesSaga(action) {
  try {
    const response = yield call(fetchAllInvoices, action.payload);
    if (response.success) {
      yield put(getAllInvoicesSuccess(response.data || {}));
    }else{
       yield put(getAllInvoicesSuccess({}));
    }
  } catch (error) {
    yield put(getAllInvoicesFailure(error));
    console.error("Placements fetch error:", error);
    // yield put(getAllPlacementsFailure(error.message));
  }
}
function* addInvoicesSaga(action) {
  try {
    const { coll, payload,qbId,syncFromQB ,postActions, supressToast=false, onSuccess,uiid,onError } = action.payload;
    let response;
    console.log("uiid",uiid)
    console.log("actin",action.payload)
    if(uiid){
    response = yield call(updateInvoice, { coll, uiid, payload,syncFromQB,qbId });
    if (response.success) {
      console.log("response", response);
      if (!supressToast) {
        showToast("Update Invoice", "success", 5000);
      }
      if (onSuccess) {
        onSuccess(response);
      }
      // yield put(getAllInvoicesSuccess(response.data || {}));
    }else{
      if(onError){
        onError(response)
      }
    }
    }else{
     response = yield call(addInvoicesApi, coll, payload,postActions);
    if (response.success) {
      console.log("response", response);
      showToast(`Invoice ${response.data?.data.invoiceNum} Generated`, "success", 5000);
      if (onSuccess) {
        onSuccess(response);
      }
      // yield put(getAllInvoicesSuccess(response.data || {}));
    }
  }
  } catch (error) {
    console.error("Placements fetch error:", error);
    showToast(error, "error", 1000);
  }
}
function* getDueInvoicesSaga(action) {
  try {
    const response = yield call(fetchAllInvoices, action.payload);
    if (response.success) {
      yield put(successDueInvoiceStart(response.data || {}));
    }else{
      yield put(successDueInvoiceStart( {}));
    }
  } catch (error) {
    console.error("Placements fetch error:", error);
    yield put(getDueInvoiceFail(error));
    // yield put(getAllPlacementsFailure(error.message));
  }
}
function* getOpenInvoicesSaga(action) {
  try {
    const response = yield call(fetchAllInvoices, action.payload);
    if (response.success) {
      yield put(successOpenInvoiceStart(response.data || {}));
    }else{
       yield put(successOpenInvoiceStart( {}));
    }
  } catch (error) {
     yield put(successOpenInvoiceStart( {}));
    console.error("Placements fetch error:", error);
    // yield put(getAllPlacementsFailure(error.message));
  }
}
function* getPaidInvoicesSaga(action) {
  try {
    const response = yield call(fetchAllInvoices, action.payload);
    if (response.success) {
      yield put(successPaidInvoiceStart(response.data || {}));
    }else{
       yield put(successPaidInvoiceStart( {}));
    }
  } catch (error) {
     yield put(successPaidInvoiceStart( {}));
    console.error("Placements fetch error:", error);
    // yield put(getAllPlacementsFailure(error.message));
  }
}
function* getEmpAllInvoicesSaga(action) {
  try {
    const response = yield call(fetchAllInvoices, action.payload);
    if (response.success) {
      yield put(successEmpAllInvoices(response.data || {}));
    }else{
       yield put(successEmpAllInvoices({}));
    }
  } catch (error) {
    console.error("Placements fetch error:", error);
    // yield put(getAllPlacementsFailure(error.message));
  }
}
function* getCurrentInvoiceStartSaga(action) {
  try {
    const response = yield call(fetchInvoicesByUiid, action.payload);
    if (response.success) {
      yield put(successGetCurrentInvoiceStart(response.data.data || {}));
    }else{
       yield put(successGetCurrentInvoiceStart({}));
    }
  } catch (error) {
    yield put(getFailCurrentInvoice(error));
  }
}

export function* watchFetchInvoices() {
  yield takeLatest(getAllInvoicesStart.type, getAllInvoicesSaga);
  yield takeLatest(addInvoicesStart.type, addInvoicesSaga);
  yield takeLatest(getDueInvoicesStart.type, getDueInvoicesSaga);
  yield takeLatest(getOpenInvoicesStart.type, getOpenInvoicesSaga);
  yield takeLatest(getPaidInvoicesStart.type, getPaidInvoicesSaga);
  yield takeLatest(getEmpAllInvoicesStart.type, getEmpAllInvoicesSaga);
  yield takeLatest(getCurrentInvoiceStart, getCurrentInvoiceStartSaga);
}
